import React from 'react';
import Grid from '@material-ui/core/Grid';

import AdUnit from '../member/AdUnit'
import MemberHeroCard from '../member/MemberHeroCard';
import MemberCommitteeAssignmentsCard from '../member/MemberCommitteeAssignementsCard';
import MemberBackgroundCard from '../member/MemberBackgroundCard';
import MemberNotFoundCard from '../member/MemberNotFoundCard';
import RecentStoriesCard from '../member/RecentStoriesCard'
import VotewatchCard from './VotewatchCard';
import PoliticalPositionsCard from './PoliticalPositionsCard';
import CTA from '../member/CTA';
import CareerHistoryCard from './CareerHistoryCard';

function getComponent(requestedComponent, member, partyStats) {
  switch (requestedComponent) {
    case 'hero':
      if (undefined === member.baseLoaded) {
      return;
      } else return (
        <Grid item key='hero' xs={12}>
          <MemberHeroCard {...member} />
        </Grid>
      );
    case 'background':
      if (undefined === member.baseLoaded) {
        return;
      } else return (
        <Grid item key='background' xs={12}>
          <MemberBackgroundCard {...member} />
        </Grid>
      );
    case 'committee':
      if (undefined === member.committeeAssignments || !member.committeeAssignments.length) {
        return;
      } else {
        return (
          <Grid item key='committee' xs={12}>
            <MemberCommitteeAssignmentsCard {...member} />
          </Grid>
        )
      };
    case 'votewatch':
      if (undefined === member.memberStats || !Object.keys(member.memberStats)
        || undefined === partyStats || !Object.keys(partyStats)
        || undefined === member.party
        || "independent" === member.party.label.toLowerCase()) {
        return;
      } else {
        return (
          <Grid item key='votewatch' xs={12}>
            <VotewatchCard member={member} partyStats={partyStats} />
          </Grid>
        )
      };
    case "stories":
      if (undefined === member.recentStories) {
        return;
      } else return (
        <Grid item key="stories" xs={12}>
          <RecentStoriesCard {...member} />
        </Grid>
      );
    case "adUnit":
			return (
        <Grid item key="adUnit" xs={12}>
          <AdUnit />
        </Grid>
      );
    case "cta":
        return (
          <Grid item key="cta" xs={12}>
            <CTA />
          </Grid>
        );
    case "positions":
      if (undefined === member ||
        undefined === member.politicalPositions ||
        undefined === member.politicalPositions.ideologyScore) {
          return;
      } else {
        return (
          <Grid item key="positions" xs={12}>
            <PoliticalPositionsCard {...member}/>
          </Grid>
        )
      };
    case "career":
      if (undefined === member ||
        undefined === member.positions) {
          return;
      } else {
        return (
          <Grid item key="career" xs={12}>
            <CareerHistoryCard {...member}/>
          </Grid>
        )
      };
    case "memberNotFound":
      return (
          <Grid item key="memberNotFound" xs={12}>
            <MemberNotFoundCard />
          </Grid>
        );
    default:
      return (
        <Grid item xs={12}>
          <h1>{requestedComponent} component not Found</h1>
        </Grid>
      );
  }
}

const MemberDetails = (props) => {
  const {
    member,
    partyStats,
    cardComponents =
    ['hero', 'background', 'positions', 'cta', 'career', 'committee', 'votewatch', 'stories', 'adUnit']
  } = props;

  let memberDetailComponents;
  if (member && Object.keys(member).length > 0) {
    if ('currentMember' in member && member.currentMember === false) {
      memberDetailComponents = [getComponent('memberNotFound', member, partyStats)];
    } else if ('baseLoaded' in member && member.baseLoaded === true) {
      memberDetailComponents = cardComponents.map((component) =>
        getComponent(component, member, partyStats)
      );
    }
  } else {
    return null;
  }
  return (
    <Grid container spacing={3}>
      {memberDetailComponents}
    </Grid>
  );
};

export default MemberDetails;
